import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { HeaderUser } from '@pages/page-cfg-users/header-user';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DayMonth, EmailCtrl, LoginCtrl } from '@documalis/_const/const';
import { formatDateInt } from '@core/_utils/date.utils';

@Component({
    selector: 'app-form-user',
    templateUrl: './form-user.component.html',
    styleUrls: ['./form-user.component.scss'],
    providers: [AutofocusDirective],
})
export class FormUserComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;

    @Input()
    public dataItem: HeaderUser = null;

    @Input()
    public userListDelegate: any;

    @Input()
    public groupListBase: any;    

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public user_Type: number;
    public firstDayOfWeek: number;

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        super(messageService);
        this.firstDayOfWeek = DayMonth.firstDayOfWeek;

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            login: [null, [Validators.required, Validators.pattern(LoginCtrl), Validators.minLength(1), Validators.maxLength(40)]],
            lastname: ['',[Validators.maxLength(255)]],
            firstname:  ['',[Validators.maxLength(255)]],
            email: ['', [Validators.pattern(EmailCtrl)]],
            desc: '',
            datel: false,
            dateexpiration: [new Date(),[Validators.required]],
            dateexpirationbool: false,
            password: '',
            passwordcf: '',
            useautoconnection: false,
            autoconnectionuser: ['',[Validators.maxLength(255)]],
            allowconfiguser: false,
            allowconfigdelegate: false,
            usertype: 0,
            allowscantouchscreen: [{value: false, disabled: false}],
            allowmodeler: [{value: false, disabled: false}],
            allowsearch: [{value: false, disabled: false}],
            allowbasket: [{value: false, disabled: false}],
            allowaddmodeldoc: [{value: false, disabled: false}],
            usedelegate: false,
            delegateuserlogin: '',
            datebegindelegate: [new Date(),[Validators.required]],
            dateenddelegate: [new Date(),[Validators.required]],
            groupList: '',
            active: false
        });
        this.initialization();
        this.user_Type = 0;
    }

    ngOnInit() {
        if (this.dataItem !== null) {
            this.dataItem.notifyParent.subscribe(success => {
                this.setCtrls(this.dataItem.usertype);
                this.resultForm.patchValue(this.dataItem);
                if (this.dataItem.duplicate === true) {
                    this.resultForm.controls['login'].enable();
                } else {
                    this.resultForm.controls['login'].disable();
                }
                this.user_Type = this.dataItem.usertype;
            })
        } else {
            this.user_Type = 0;
            this.setCtrls(this.user_Type);
            this.resultForm.controls['login'].enable();
        }
    }

    ngOnDestroy() {
        if (this.dataItem !== null) {
            this.dataItem.notifyParent.unsubscribe()
        }
    }

    public onUserType(event) {
        this.user_Type = event;
        this.setCtrls(this.user_Type);
    }

    private setCtrls(aValue) {
        if (aValue===0) {
            this.resultForm.controls['allowscantouchscreen'].enable();  
            this.resultForm.controls['allowmodeler'].enable();                              
            this.resultForm.controls['allowmodeler'].enable();                              
            this.resultForm.controls['allowsearch'].enable();
            this.resultForm.controls['allowbasket'].enable();             
            this.resultForm.controls['allowaddmodeldoc'].enable();       
        } else {
            this.resultForm.controls['allowscantouchscreen'].disable();  
            this.resultForm.controls['allowmodeler'].disable();                              
            this.resultForm.controls['allowmodeler'].disable();                              
            this.resultForm.controls['allowsearch'].disable();
            this.resultForm.controls['allowbasket'].disable();             
            this.resultForm.controls['allowaddmodeldoc'].disable();       
        }
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            data: this.resultForm.getRawValue(),
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            if (this.ctrlPass() === false) {
                return;
            }
            if (this.dataItem) {
                if (this.ctrlDuplicate() === false) {
                    return;
                }
                wRequest = this.setValues(wRequest);
            } else {
                wRequest.data.autogenerated = false;
                wRequest.data.login = this.resultForm.controls.login.value.trim();
            }
            wRequest.data.datebegindelegate = formatDateInt(wRequest.data.datebegindelegate, false);
            wRequest.data.dateenddelegate = formatDateInt(wRequest.data.dateenddelegate, false);
            wRequest.data.dateexpiration = formatDateInt(wRequest.data.dateexpiration, false);        

            this.onValidate.emit(wRequest);
        }
    }

    private setValues(aRequest) {
        if (this.dataItem.duplicate === true) {
            aRequest.data.login = this.resultForm.controls.login.value.trim();
            aRequest.data.autogenerated = false;
        } else {
            aRequest.data.login = this.dataItem.login.trim();
            aRequest.data.autogenerated = this.dataItem.autogenerated;
        }
        return aRequest;
    }

    private ctrlPass() {
        if (this.resultForm.value.password !== this.resultForm.value.passwordcf) {
            this._messageService.addWarn(this.translate.instant('Cf_PassDiff'));
            return false;
        } else {
            return true;
        }
    }

    private ctrlDuplicate() {
        if (this.dataItem.duplicate === false) {
            return true;
        }
        if (this.dataItem.login === this.resultForm.controls.login.value) {
            this._messageService.addWarn(this.translate.instant('Cf_LoginEqual'));
            return false;
        } else {
            return true;
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private initialization() {
        this.keys = {
            login: {
                label: this.translate.instant('Cf_Login'),
                pattern: '',
            },
            lastname: {
                label: this.translate.instant('Cf_LastName'),
                pattern: '',
            },
            firstname: {
                label: this.translate.instant('Cf_FirstName'),
                pattern: '',
            },            
            email: {
                label: this.translate.instant('Cf_WrongMail'),
                pattern: '',
            },
            autoconnectionuser: {
                label: this.translate.instant('Cf_AutoCnxUser'),
                pattern: '',
            },
            dateexpiration: {
                label: this.translate.instant('Date_KO'),
                pattern: '',
            },
            datebegindelegate: {
                label: this.translate.instant('Date_KO'),
                pattern: '',
            },
            dateenddelegate: {
                label: this.translate.instant('Date_KO'),
                pattern: '',
            }

        };
    }
}
